import ComponentErrorBoundary from '@/Layouts/ComponentErrorBoundary';
import React, { useState, useEffect } from 'react';

const weatherIconStyle = {
    position: 'absolute',
    top: '120px',
    right: '10px',
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '14px',
};

const WeatherOverlayComponent = React.memo(({ show, lat, lng }) => {
    const [weatherData, setWeatherData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchWeatherData = async (latitude, longitude) => {
        if (!latitude || !longitude) return;

        try {
            setLoading(true);
            setError(null);

            const apiKey = process.env.REACT_APP_OPENWEATHERMAP_API_KEY;
            const response = await fetch(
                `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=metric&appid=${apiKey}`
            );

            if (response.ok) {
                const data = await response.json();
                setWeatherData(data);
            } else {
                setError('Failed to fetch weather data');
            }
        } catch (err) {
            setError('Failed to fetch weather data');
            console.error('fetchWeatherData', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (show && lat && lng) {
            fetchWeatherData(lat, lng);
        }
    }, [show, lat, lng]);
    if (!show) return null;

    if (loading) {
        return (
            <div style={weatherIconStyle}>
                <span>Loading weather...</span>
            </div>
        );
    }

    if (error) {
        return (
            <div style={weatherIconStyle}>
                <span>Weather unavailable</span>
            </div>
        );
    }

    if (!weatherData) return null;

    const { main, weather } = weatherData;
    const weatherIcon = weather && weather[0] ? `https://openweathermap.org/img/wn/${weather[0].icon}.png` : null;

    return (
        <div style={weatherIconStyle}>
            {weatherIcon && <img src={weatherIcon} alt="Weather icon" width="40" height="40" />}
            <div>
                <div>{weather && weather[0] ? weather[0].main : 'Unknown'}</div>
                <div>{main ? `${Math.round(main.temp)}°C` : ''}</div>
            </div>
        </div>
    );
});

const WeatherOverlay = (props) => (
    <ComponentErrorBoundary componentErrorMessage={props?.componentErrorMessage || 'Failed to load'}>
        <WeatherOverlayComponent {...props} />
    </ComponentErrorBoundary>
);

export default WeatherOverlay;
